/**
 * Created by ChrisMuto on 6/28/17.
 */
export const REQUEST_AUDIENCES = "REQUEST_AUDIENCES";
export const RECEIVE_AUDIENCES = "RECEIEVE_AUDIENCES";
export const RECEIVE_AUCIENCES_ERROR = "RECEIVE_AUCIENCES_ERROR";



// WEBPACK FOOTER //
// ./src/modules/audiences/types.js